import type React from "react";
import { useAppSelector } from "src/common/state/hooks";
import Spinner from "../../../common/components/Loader/Spinner";
import { getGraphLayout, selectSelectedContentId } from "../state/graphLegacy";
import SVGGraph from "./SVGGraph";

type Props = { loading: boolean };

const SVGGraphContainer: React.FC<Props> = ({ loading }) => {
  const [nodes, layout, links, hiddenSceneNodes] = useAppSelector(getGraphLayout);

  const selectedContentId = useAppSelector(selectSelectedContentId);

  return loading ? (
    <div
      style={{
        width: "100%",
        height: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spinner />
    </div>
  ) : (
    <SVGGraph
      nodes={nodes}
      layout={{ ...layout, height: layout.height + 230 }}
      links={links}
      selectedContentId={selectedContentId as number}
      hiddenSceneNodes={hiddenSceneNodes}
    />
  );
};

export default SVGGraphContainer;
